"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateGraphLines = exports.calculatePnl = void 0;
const calculationsCore_1 = require("../calculationsCore");
const instrumentUtils_1 = require("./instrumentUtils");
const pnlCalculationFunctions_1 = require("./pnlCalculationFunctions");
const termStructure_1 = require("./termStructure");
__exportStar(require("./instrumentUtils"), exports);
/**
 * Calculates the pnl in settlement currencies.
 */
const calculatePnl = (domains, domainLength, positions, tickers, termStructure, currencyType, isOffsetActive) => {
    const todayLineSum = new Array(domainLength).fill(0);
    const expireLineSum = new Array(domainLength).fill(0);
    for (const position of positions) {
        const ticker = tickers[position.instrument];
        const domain = domains[(0, calculationsCore_1.getBaseCurrencyFromInstrumentString)(position.instrument)];
        /**
         * SimulatedPoint depends on the chart can be already usd or percent. If it is percent we need to multiply by index otherwise
         * it is just usd and we use usd
         */
        const positionPnl = domain.map((simulatedPoint) => pnlCalculationFunctions_1.pnlFunctions[(0, instrumentUtils_1.getInstrumentType)(position.instrument)](position, ticker, simulatedPoint, termStructure, currencyType, isOffsetActive));
        for (let i = 0; i < positionPnl.length; i++) {
            todayLineSum[i] += positionPnl[i].todayPt;
            expireLineSum[i] += positionPnl[i].expirePt;
        }
    }
    return {
        todayLineSum,
        expireLineSum,
    };
};
exports.calculatePnl = calculatePnl;
/**
 *
 * @param domains
 * @param positions
 * @param tickers
 * @param isOffsetActive
 * @param currencyType
 * @param calculationTimestamp This is the simulation calculation time.
 * @param currentTimestamp This is the time at calculation. It is important because we calculate interest rates based on how much time there is left
 * and that one we get with current timestamp.
 * @returns
 */
const calculateGraphLines = (domains, domainLength, positions, tickers, isOffsetActive, currencyType, calculationTimestamp, currentTimestamp) => {
    if (Object.keys(tickers).length === 0 || positions.length === 0) {
        return {
            expireLine: {
                values: [],
            },
            todayLine: {
                values: [],
            },
            breakevenPoints: [],
        };
    }
    const termStructure = (0, termStructure_1.calculateImpliedRAndT)(tickers, calculationTimestamp, currentTimestamp);
    const pnl = (0, exports.calculatePnl)(domains, domainLength, positions, tickers, termStructure, currencyType, isOffsetActive);
    return {
        expireLine: {
            values: pnl.expireLineSum,
        },
        todayLine: {
            values: pnl.todayLineSum,
        },
        breakevenPoints: [],
    };
};
exports.calculateGraphLines = calculateGraphLines;
